// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1kuP1","file":"styles_file__13k0U"};